<template>
  <div class="bubble-section">
    <bubbles v-if="bubbles" />
  </div>
</template>
<script>

import Bubbles from '../components/Bubbles'

export default {
  components: {
    Bubbles
  },
  data () {
    return {
      bubbles: false
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.setBubbles()
    })
  },
  methods: {
    setBubbles () {
      if (this.$el.classList.contains('in-viewport') || this.$el.classList.contains('above-viewport') || this.$el.classList.contains('fully-in-viewport')) {
        if (!this.bubbles) {
          this.bubbles = true
        }
      } else {
        if (this.bubbles) {
          this.bubbles = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/sections/BubbleSection.vue